import { initializeApp } from 'firebase/app';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';

export const firebaseConfig = {
  apiKey: 'AIzaSyBhpVkhf02bz-v4chDIbZcPp2_FbJ8jEiw',
  authDomain: 'linguabuddy-9d88f.firebaseapp.com',
  projectId: 'linguabuddy-9d88f',
  storageBucket: 'linguabuddy-9d88f.firebasestorage.app',
  messagingSenderId: '919018667136',
  appId: '1:919018667136:web:19c923354a4e9cc8f27a65',
  measurementId: 'G-424P5VFNFQ',
};

export const firebaseApp = initializeApp(firebaseConfig);

// In local dev, route Firestore to the local emulator so the client and the
// (emulated) Cloud Functions share one datastore. Guarded by REACT_APP_USE_EMULATOR
// so production builds are completely unaffected. Must run before any Firestore use;
// all utils call getFirestore(firebaseApp), which returns this same connected instance.
// REACT_APP_USE_FIRESTORE_EMULATOR overrides REACT_APP_USE_EMULATOR independently, so
// Functions can stay local (e.g. `serve:live-data`) while Firestore reads hit production.
const useFirestoreEmulator =
  process.env.REACT_APP_USE_FIRESTORE_EMULATOR ?? process.env.REACT_APP_USE_EMULATOR;
if (useFirestoreEmulator === 'true') {
  try {
    // Android emulator WebView loads from 10.0.2.2 and must reach the host via 10.0.2.2.
    const host =
      typeof window !== 'undefined' && window.location.hostname === '10.0.2.2'
        ? '10.0.2.2'
        : '127.0.0.1';
    connectFirestoreEmulator(getFirestore(firebaseApp), host, 8080);
    // eslint-disable-next-line no-console
    console.log(`🔥 Firestore → emulator at ${host}:8080`);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Failed to connect Firestore emulator:', e);
  }
}
